import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();
});

const body = document.querySelector("body");

function initLoopSliderSmooth() {
  const sliderWraps = document.querySelectorAll('.loopSlider .loopslider_wrap');

  sliderWraps.forEach(sliderWrap => {
    const ul = sliderWrap.querySelector('ul');
    if (!ul) return;

    // 複製済みならスキップ
    if (sliderWrap.querySelectorAll('ul').length > 3) return; // 元1 + 複製2 = 3

    // 複製を左に追加（右流しだから左側を埋める）
    const clone1 = ul.cloneNode(true);
    const clone2 = ul.cloneNode(true);
    sliderWrap.insertBefore(clone2, ul); // 左に追加
    sliderWrap.insertBefore(clone1, ul); // 左に追加

    // wrap の幅を全ての ul の合計幅に設定
    const uls = sliderWrap.querySelectorAll('ul');
    let totalWidth = 0;
    uls.forEach(u => totalWidth += u.offsetWidth);
    sliderWrap.style.width = totalWidth + 'px';

    // アニメーション
    const singleWidth = ul.offsetWidth;
    const animationDuration = 60000;

    sliderWrap.animate([
      { transform: `translateX(-${singleWidth}px)` }, // 左から開始
      { transform: 'translateX(0)' }                 // 右へ流れる
    ], {
      duration: animationDuration,
      iterations: Infinity,
      easing: 'linear'
    });
  });
}

// 初期化
document.addEventListener('DOMContentLoaded', initLoopSliderSmooth);
window.addEventListener('load', initLoopSliderSmooth);
window.addEventListener('resize', initLoopSliderSmooth);



document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains("index")) return;

  let tabItems = document.querySelectorAll(".tab-btn"); // ← let に変更
  const tabPanels = document.querySelectorAll(".tab-panel");
  if (!tabItems.length || !tabPanels.length) return;

  // タブ状態リセット
  function resetTabs() {
    tabItems.forEach((t) => t.classList.remove("active"));
    tabPanels.forEach((panel) => {
      panel.classList.remove("active");
      const textBlock = panel.querySelector(".index-cate_texts");
      if (textBlock) textBlock.classList.remove("show");
    });
  }

  // モバイルビュー（全開）
  function setMobileView() {
    resetTabs();
    tabItems.forEach((t) => t.classList.add("active"));
    tabPanels.forEach((panel) => {
      panel.classList.add("active");
      const textBlock = panel.querySelector(".index-cate_texts");
      if (textBlock) textBlock.classList.add("show");
    });
  }

  // デスクトップビュー（current があればそれを優先）
  function setDesktopView() {
    resetTabs();

    // current クラスがあるタブを探す（無ければ 0 番目）
    let initialIndex = Array.from(tabItems).findIndex(tab => tab.classList.contains("current"));
    if (initialIndex === -1) initialIndex = 0;

    // 初期表示
    tabItems[initialIndex].classList.add("active");
    tabPanels[initialIndex].classList.add("active");
    const firstText = tabPanels[initialIndex].querySelector(".index-cate_texts");
    if (firstText) firstText.classList.add("show");

    // タブクリック処理
    tabItems.forEach((tabItem, idx) => {
      tabItem.addEventListener("click", () => {
        resetTabs();
        tabItem.classList.add("active");

        const targetPanel = tabPanels[idx];
        targetPanel.classList.add("active");

        const textBlock = targetPanel.querySelector(".index-cate_texts");
        if (textBlock) setTimeout(() => textBlock.classList.add("show"), 300);
      });
    });
  }

  // ビュー切り替え（リサイズ含む）
  function updateView() {
    // cloneNode でイベントを消去してリフレッシュ
    document.querySelectorAll(".tab-btn").forEach((tab) => {
      const clone = tab.cloneNode(true);
      tab.replaceWith(clone);
    });

    // 差し替えた後に最新の NodeList を取得
    tabItems = document.querySelectorAll(".tab-btn");

    if (window.innerWidth < 1024) {
      setMobileView();
    } else {
      setDesktopView();
    }
  }

  updateView(); // 初期表示
  window.addEventListener("resize", updateView); // リサイズ監視
});


gsap.registerPlugin(ScrollToPlugin);
/*----------------------------------------
smooth scroll page内リンク
------------------------------------------*/
window.addEventListener("load", () => {
  const navLinks = document.querySelectorAll('a[href^="#"]');
  const header = document.querySelector('.header');

  navLinks.forEach((navLink) => {
    navLink.addEventListener("click", (e) => {
      e.preventDefault();
      const id = navLink.getAttribute("href");
      const headerHeight = header ? header.offsetHeight : 0;

      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: id,
          offsetY: headerHeight  // ← headerの高さを使う
        }
      });
    });
  });
});

/*----------------------------------------
smooth scroll page外リンク
------------------------------------------*/
window.addEventListener('load', () => {
  if (location.hash) {
    const header = document.querySelector('.header');
    const headerHeight = header ? header.offsetHeight : 0;
    const urlHash = location.hash;

    setTimeout(() => {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: urlHash,
          offsetY: headerHeight
        }
      });
    }, 80);
  }
});

const buttons = document.querySelectorAll('.works-cate_btn');
buttons.forEach(button => {
  button.addEventListener('click', () => {
    buttons.forEach(btn => btn.classList.remove('active'));
    button.classList.toggle('active');
  });
});

// スライド要素を取得
const slides = document.querySelectorAll('.swiper-slide');

// 投稿が6個以上ある場合のみSwiperを初期化
if(slides.length >= 5) {
  let getTranslate;
  let slideWidth;

  var mySwiper = new Swiper('.swiper-container', {
    speed: 14000,
    slidesPerView: 'auto',
    loop: true,
    freeMode: true,
    freeModeMomentum: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    on: {
      touchEnd: () => {
        getTranslate = mySwiper.getTranslate(); // スライドの現在位置を取得
        slideWidth = document.querySelector('.swiper-slide-active').offsetWidth; // スライドの横幅を取得
        mySwiper.setTranslate(getTranslate - slideWidth); // translateを更新
        mySwiper.setTransition(14000); // transitionを更新
      },
    }
  });
}

//ハンバーガーメニュー
let button = document.querySelector('.hd_menu_btn');  //ハンバーガーメニューボタン
let nav_box = document.querySelector('.hd_nav_box');  //ハンバーガーメニュー中身
  button.addEventListener('click', function() {   // クリックしたとき


    if(nav_box.classList.contains('is_open') == true){  // .hd_nav_box　に　is_openクラスがついてたら

      nav_box.classList.remove("is_open");  //　メニュー表示　のクラスを削除　中身が見えない
      button.classList.remove("is_close");  //　閉じるボタン　のクラスを削除　元の三本線

    }else{

      nav_box.classList.add("is_open"); //　メニュー表示　のクラスをつける　中身が見える
      button.classList.add("is_close"); //　閉じる表示ボタン　のクラスをつける　×表示
    }
  });

  let links = document.querySelectorAll('.hd_nav_link');
  links.forEach((link) => {
    link.addEventListener('click', function() {
      setTimeout(() => {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      }, 100);
    });
  });

  let business_links = document.querySelectorAll('.dropdown__list');
  business_links.forEach((business_links) => {
    business_links.addEventListener('click', function() {
      setTimeout(() => {
        nav_box.classList.remove("is_open");
        button.classList.remove("is_close");
      }, 100);
    });
  });

//下層タイトルアニメーション
document.addEventListener("DOMContentLoaded", () => {
  const element = document.querySelector(".cmn-ttl_en");
  if (!element) return; // 要素がなければ処理中断

  const text = element.textContent;
  element.textContent = "";
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

  // 各文字をspanに分割
  text.split("").forEach(char => {
    const span = document.createElement("span");
    span.textContent = char === " " ? " " : letters[Math.floor(Math.random() * letters.length)];
    element.appendChild(span);
  });

  const spans = element.querySelectorAll("span");

  spans.forEach((span, index) => {
    if(span.textContent !== " ") {
      let iterations = 0;
      const interval = setInterval(() => {
        span.textContent = letters[Math.floor(Math.random() * letters.length)];
        iterations++;
        // ランダム変化後に元の文字に置き換え
        if (iterations > 10 + index * 2) {
          clearInterval(interval);
          span.textContent = text[index];
        }
      }, 25);
    }
  });
});

//ヘッダー動き
window.addEventListener('scroll', () => {
  const header = document.querySelector('.header');
  const windowWidth = window.innerWidth;

  if (windowWidth >= 1024) {
    // PC: スクロールで表示・非表示
    if (window.scrollY > 50) {
      header.classList.add('is-visible');
    } else {
      header.classList.remove('is-visible');
    }
  } else {
    // 1024px以下: 常に表示
    header.classList.add('is-visible');
  }
});

if (document.body.classList.contains("index")) {
// index > about アニメーション
document.addEventListener("DOMContentLoaded", () => {
  const trigger = document.querySelector(".index-about_title");
  const paths = document.querySelectorAll("path");
  const drawDuration = 200; // 線を描く時間を0.2秒に短縮

  // パス長さ設定
  paths.forEach(path => {
    const length = path.getTotalLength();
    path.style.strokeDasharray = length;
    path.style.strokeDashoffset = length;
    path.style.transition = `stroke-dashoffset ${drawDuration}ms linear`;
  });

  // IntersectionObserver 作成
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        paths.forEach((path, i) => {
          setTimeout(() => {
            path.style.strokeDashoffset = 0;
            setTimeout(() => {
              path.style.transition = "fill-opacity 1s ease";
              path.style.fillOpacity = 1;
            }, drawDuration);
          }, i * 100); // パスごとに少しずらす
        });
        observer.unobserve(trigger); // 一度アニメーションしたら observer を停止
      }
    });
  }, { rootMargin: "0px 0px -30% 0px" });

  // 安全に observe
  observer.observe(trigger);
});
}

//コンテンツアニメーション　（下から上へ）
document.addEventListener('DOMContentLoaded', function () {
  // スクロールまたはロード時に実行する関数
  function checkFadeIn() {
    var scroll = window.pageYOffset || document.documentElement.scrollTop;//現在のスクロール量を取得
    var windowHeight = window.innerHeight;//画面の高さを取得

    document.querySelectorAll('.fadein').forEach(function (el) {//クラスがついてる要素に処理
      var imgPos = el.getBoundingClientRect().top + scroll;

      if (scroll > imgPos - windowHeight + windowHeight / 8) {//要素が画面下から1/8に入ったら表示開始
        el.classList.add('active'); // 一度表示されたらそのまま
      }
    });
  }

  // ページ読み込み時に初期状態をチェック
  checkFadeIn();

  // スクロール時に表示の位置をチェック
  window.addEventListener('scroll', checkFadeIn);
});

// 詳細ページのボタン調整
document.addEventListener("DOMContentLoaded", () => {
  const pagination = document.querySelector(".works-pager"); // ページネーション要素を取得
  if (!pagination) return;

  let hasNext = false; // 「次へ」があるか
  let hasPrev = false; // 「前へ」があるか

  const links = pagination.querySelectorAll(".works-pager_num");

  links.forEach(link => {
    const text = link.querySelector(".news-details_pagination_text");
    if (!text) return;

    const txt = text.textContent.trim();
    if (txt === "次へ") hasNext = true;  // 「次へ」が見つかれば true
    if (txt === "前へ") hasPrev = true;  // 「前へ」が見つかれば true
  });

  if (!hasNext) {
    // 「次へ」が無い → 最新記事 → .is-latest を付与
    pagination.classList.add("is-latest");
  } else if (!hasPrev) {
    // 「前へ」が無い → 一番古い記事 → .is-oldest を付与
    pagination.classList.add("is-oldest");
  } else {
    // どちらもある場合は特にクラスを付けない（必要なら追加可）
  }
});

// // //お問い合わせバリデーション
if(document.body.classList.contains("contact")){
  topValidation('zip', 'address01', 'address02');
}

//お問い合わせフォームアニメーション
document.addEventListener('tccf7:scrollTo', e => {
  const header = document.querySelector('.anchor-header');
  const headerHeight = header ? header.offsetHeight : 0;

  gsap.to(window, {
    duration: 1,
    scrollTo: {
      y: "#" + e.detail.id,
      offsetY: headerHeight
    },
    ease: "power2.inOut"
  });

});

//事業内容　リアルタイムで表示中のコンテンツにカレントを付ける
document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const sections = document.querySelectorAll('.service-wrap');
  const tabs = document.querySelectorAll('.tab-btn');
  if (!sections.length || !tabs.length) return;

  let observer = null;

  function clearObserver() {
    if (observer) {
      sections.forEach(section => observer.unobserve(section));
      observer.disconnect();
      observer = null;
    }
  }

  function clearActive() {
    tabs.forEach(btn => btn.classList.remove('active'));
  }

  function setActiveById(id) {
    clearActive();
    const activeTab = document.querySelector(`.tab-btn a[href="#${id}"]`);
    if (activeTab) activeTab.closest('.tab-btn').classList.add('active');
  }

  function setMobileView() {
    clearObserver();
    tabs.forEach(btn => btn.classList.add('active'));
  }

  function setDesktopView() {
    clearActive();

    // IntersectionObserver のセットアップ
    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) setActiveById(entry.target.id);
      });
    }, {
      root: null,
      threshold: 0.3
    });

    sections.forEach(section => observer.observe(section));

    // タブクリック処理
    if (body.classList.contains("service")) {
      document.querySelectorAll('.tab-btn a').forEach(link => {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          clearActive();
          this.closest('.tab-btn').classList.add('active');
          const target = document.querySelector(this.getAttribute('href'));
          if (target) target.scrollIntoView({ behavior: 'smooth' });
        });
      });
    }
  }

  // 画面幅に応じて切り替え
  function updateView() {
    if (window.innerWidth < 1024) setMobileView();
    else setDesktopView();
  }

  updateView(); // 初期表示
  window.addEventListener('resize', updateView); // リアルタイム監視
});

